// extracted by mini-css-extract-plugin
export default {"downDropStyle":"SectionTabs_downDropStyle__XwfEs","content":"SectionTabs_content__7F2fg","dropClass":"SectionTabs_dropClass__azoGr","unidentified":"SectionTabs_unidentified__Rz4sK"};